import { useEffect, useState } from "react";
import { Link, Title } from "./Texts";
import { Button, Grid, Typography } from "@mui/material";
import cloud from "../../icons/cloud-download.png";
import { useAppSelector } from "../../store";

export default function LienTeleExpertise() {

	const { user } = useAppSelector((s) => s.auth);
	const { links } = useAppSelector((s) => s.expertise);

	const [lienTeleExpertise, setLienTeleExpertise] = useState("");

	useEffect(() => {
		const data = {
			action: "NouvelleTLE",
			expert: {
				idTechPs: user?.idTechPs,
				libelle: user?.libelle,
				idNatPs: user?.idNatPs,
			}
		}
		const jsonString = JSON.stringify(data);
		const encodedJson = window.btoa(jsonString)
		setLienTeleExpertise(window.config.endpoints.monSisraBaseUrl + "?encodedJson=" + encodedJson);
	}, [user]);

	const copyToClipboard = () => {
		if (navigator.clipboard) { // default: modern asynchronous API
			return navigator.clipboard.writeText(lienTeleExpertise);
		} else {
			// @ts-ignore
			if (window.clipboardData && window.clipboardData.setData) {     // for IE11
				// @ts-ignore
				window.clipboardData.setData('Text', text);
				return Promise.resolve();
			} else {
				// workaround: create dummy input
				const input = document.createElement("input");
				input.type = "text";
				input.value = lienTeleExpertise;
				document.body.append(input);
				input.focus();
				input.select();
				document.execCommand('copy');
				input.remove();
				return Promise.resolve();
			}
		}
	};

	const openLink = () => {
		const win = window.open(links.guideTeleexpertise);
		win?.focus();
	};

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Lien d'accès rapide pour vos requérants"} />
			</Grid>

			<Grid item>
				<Grid container spacing={1} alignItems={"center"}>
					<Grid item>
						Vous pouvez partager
					</Grid>
					<Grid item >
						<Link text="CE LIEN" href={lienTeleExpertise} />
					</Grid>
					<Grid item>
						à vos confrères pour leur faciliter la demande d'expertise.
					</Grid>
					<Grid item>
						<Button variant="contained" onClick={copyToClipboard}>
							Copier le lien
						</Button>
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid item>
					Ce lien peut être affiché où vous le jugerez utile : le site web de votre établissement, de votre cabinet,
					ou encore dans votre signature de mail ou pied de page de vos modèles de comptes rendus médicaux ...
					Vos requérants n'auront qu'à cliquer dessus pour vous poser directement une question en téléexpertise.
				</Grid>
			</Grid>
			<Grid item alignSelf={"center"}>
				<Grid container spacing={1} alignItems={"center"}>
					<Grid item >
						<Typography color={"primary"} sx={{ fontWeight: "bold", fontSize: "120%" }}>
							En savoir plus ? Téléchargez le guide de la téléexpertise
						</Typography>
					</Grid>
					<Grid item>
						<Button component="span" onClick={openLink}>
							<img src={cloud} alt={"nuage 'cloud'"} width={40} />
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid >

	);
}
